export function formatMamAmount(amount: number): string {
  return amount.toFixed(2);
}

export function earnedMamTitle(amount: number): string {
  return `This booking earned you ${formatMamAmount(amount)} MAM.`;
}

export function earnedMamDetail(amount: number): string {
  return `That's €${formatMamAmount(amount)} you can redeem on ski passes, gear rental or a future trip.`;
}
